export default __webpack_public_path__ + "static/media/speaker-1.698b4c4a.png";